export const inlineFieldSx = {
  '& .MuiInput-underline:before': {
    borderBottomColor: 'rgba(0,0,0,0.07)',
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
    borderBottomColor: 'rgba(0,0,0,0.28)',
  },
} as const
